//Take in two objects (new and old), return one object that has the LOST stuff from old.

export function getObjectKeyDiff(newObj, oldObj) {
  let removedData = {};

  //Loop through each value in oldObj. If the same key does not exist in newObj, add the data to removedData
  Object.keys(oldObj).forEach(key => {
    const model = oldObj[key];
    if (!newObj[key]) {
      removedData[key] = model;
    }
  });

  return {
    ...removedData
  };
} //EX: {a, b, c}, {a,c}, return {b}

//Take in two objects and return the NEW keys
export function getObjectAdditions(newObj, oldObj) {
  let payload = {};
  const oldObjKeys = Object.keys(oldObj);

  Object.keys(newObj).forEach(key => {
    if (!oldObjKeys.includes(key)) {
      const newValue = newObj[key];
      //NOTE: this will crumble on arrays
      payload[key] = typeof newValue === "object" ? { ...newValue } : newValue;
    }
  });

  return payload;
}



// WEBPACK FOOTER //
// ./src/helpers/get-object-key-diff.js